import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetUpdateGame = () => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params: undefined,
                method: 'get',
                url: urls.GET_LIST_GAMES
            });
            await DefaultApi({
                params: undefined,
                method: 'get',
                url: urls.GET_LIST_LIVE_GAMES
            });
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetUpdateGame as SetGetUpdateGame
}